import React, { useEffect, useState } from "react"
import ParticipantManagement from "./ParticipantManagement"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import ApplicationService from "../../services/applications/Application.service"
import { Alert } from "reactstrap"
import { Link } from "react-router-dom/cjs/react-router-dom"

let appService = null

function Messaging() {
  const [selectedMedium, setSelectedMedium] = useState("")
  const [targetGroup, settargetGroup] = useState("")
  const [showParticipants, setshowParticipants] = useState(false)
  const [participants, setparticipants] = useState([])
  const [messageBody, setmessageBody] = useState("")
  const [subject, setsubject] = useState("")
  const [disableButton, setdisableButton] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)
  }, [])
  const handleTargetGroup = e => {
    if (
      e.target.value == "SELECTED CLIENTS" ||
      e.target.value == "SELECTED COMPANIES"
    ) {
      setshowParticipants(true)
    } else {
      setshowParticipants(false)
    }
    settargetGroup(e.target.value)
  }

  // Handle the selection of communication medium
  const handleMediumSelection = medium => {
    setSelectedMedium(medium)
  }

  const handleParticipants = list => {
    list = list.filter((item, index) => list.indexOf(item) === index)
    setparticipants(list)
  }

  const handleSubmitMessage = async () => {
    if (targetGroup == "") {
      alert("Please select target group!")
      return
    }
    if (selectedMedium == "") {
      alert("Please select communication medium!")
      return
    }

    if (
      targetGroup == "SELECTED CLIENTS" ||
      targetGroup == "SELECTED COMPANIES"
    ) {
      if (participants.length == 0) {
        alert("Please select participants")
        return
      }
    }

    if (subject == "") {
      alert("Please enter a subject for your message!")
      return
    }

    if (messageBody == "") {
      alert("Please enter message!")
      return
    }

    setShowSuccessAlert(false)

    const data = {
      message: messageBody,
      communication_type: selectedMedium,
      recipient_group: targetGroup,
      selected_recipients: participants,
      subject: subject,
    }

    setdisableButton(true)
    appService.sendBulkNotification(data).then(response => {
      if (response.status) {
        console.log("response => ", response)
        setShowSuccessAlert(true)
      }
      setdisableButton(false)
    })
  }

  const clearFields = () => {
    settargetGroup("")
    setsubject("")
    setmessageBody("")
    setparticipants([])
    setSelectedMedium("")
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Messaging</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Messaging</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    You will use this page to message clients and companies.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
          {/* Add the "View Message History" link */}
          <Row>
            <Col md="8"></Col>
            <Col md="4"><Link to="/message-history"><h5><i className="fas fa-history"></i> {" "}View Message History</h5></Link></Col>
          </Row>
          <br></br>

          {/* Show success alert when a message is sent successfully */}
          {showSuccessAlert && (
            <Alert color="success">
              Message sent successfully!
              <button
                type="button"
                className="close"
                onClick={() => setShowSuccessAlert(false)}
              >
                &times;
              </button>
            </Alert>
          )}
          <label for="target-group">Select Target Group</label>
          <select
            id="target-group"
            defaultValue={targetGroup}
            onChange={handleTargetGroup}
            className="form-control"
          >
            <option className="form-control" value={""}>
              None
            </option>
            <option className="form-control" value={"ALL CLIENTS"}>
              All Clients
            </option>
            <option className="form-control" value={"SELECTED CLIENTS"}>
              Selected Clients
            </option>
            <option className="form-control" value={"ALL COMPANIES"}>
              All Companies
            </option>
            <option className="form-control" value={"SELECTED COMPANIES"}>
              Selected Companies
            </option>
          </select>
          <br></br>

          {/* Display the selected communication medium */}
          <label>Communication Medium</label>
          <select
            defaultValue={selectedMedium}
            onChange={e => setSelectedMedium(e.target.value)}
            className="form-control"
          >
            <option>None</option>
            <option className="form-control" value={"EMAIL"}>
              Email
            </option>
            <option className="form-control" value={"SMS"}>
              SMS Messaging
            </option>
            <option className="form-control" value="BOTH">
              Both Email and SMS
            </option>
          </select>
          <br></br>

          {showParticipants ? (
            <div>
              <ParticipantManagement
                targetGroup={targetGroup}
                handleParticipants={handleParticipants}
              />
            </div>
          ) : null}

          <div>
            <label>Subject</label>
            <input
              defaultValue={subject}
              onChange={e => setsubject(e.target.value)}
              type="text"
              className="form-control"
            ></input>
            <br></br>

            <label>Message Body</label>
            <textarea
              defaultValue={messageBody}
              onChange={e => setmessageBody(e.target.value)}
              rows={8}
              className="form-control"
            ></textarea>
          </div>

          <br></br>
          <Row>
            <Col md="10"></Col>
            <Col md="2">
              <button
                onClick={handleSubmitMessage}
                className="btn btn-primary pull-right"
                disabled={disableButton}
              >
                Send Message
              </button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Messaging
